import { OR } from './place'

/** The picker's one refusal sentence (SA-1051 spec §8.1); the sectors editor re-exports it. */
export const unknownPlaceText = (code: string): string => `${code} is not an airport we know. Check the code or search by city.`

/** SA-1052 (spec §5.1): the customer's alternatives, worded once. */
export const EITHER = 'Either'
export const alternativesText = (codes: string[]): string => `${EITHER} ${codes.join(OR)}`
export const ADD_ALTERNATIVE = 'Add an alternative'
export const ANOTHER_ALTERNATIVE = 'Another airport the customer accepts'
/** Closes the Add panel without adding (SA-1074). */
export const CANCEL_ALTERNATIVE = 'Cancel'
